import React from "react";

import {
  Actions,
  Bar,
  ContextText,
  NavButton,
  Title,
} from "./styled";

export default function TrailContextBar({
  context,
  onBack,
  onNext,
  onPrevious,
}) {
  if (!context?.trailId) return null;

  return (
    <Bar>
      <ContextText>
        <span>Learning Path</span>
        <Title>{context?.trailTitle || "Path item"}</Title>
      </ContextText>
      <Actions>
        <NavButton type="button" onClick={onBack}>Back to path</NavButton>
        <NavButton type="button" onClick={onPrevious} disabled={!context?.previousItem}>Previous</NavButton>
        <NavButton type="button" onClick={onNext} disabled={!context?.nextItem}>Next</NavButton>
      </Actions>
    </Bar>
  );
}
